import React, { FC, ReactNode } from "react";

import { Box, Stack, Typography, Card } from "@components/base";

interface OrganizationSetting {
  title: string;
  description?: ReactNode;
  setting: ReactNode;
}

const OrganizationSetting: FC<OrganizationSetting> = ({
  title,
  description,
  setting,
}) => (
  <Card color="grey">
    <Box p={2}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="body1">{description}</Typography>
        <Box>{setting}</Box>
      </Stack>
    </Box>
  </Card>
);

export default OrganizationSetting;
